/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query SenderIdDirectoryReadUniqueQuery($senderIdDirectoryId: ID!) {
  SenderIdDirectoryReadUnique(senderIdDirectoryId: $senderIdDirectoryId) {
    id,
    displayName,
    message,
    status
  }
}
`
